import { connect } from 'react-redux';
import SearchButton from '../components/SearchButton';
import { setModalSearchBoxState } from '../actions/SearchBoxAction';

const mapDispatchToProps = (dispatch) => ({
    setModalSearchBoxState: (isOpen = false) => {
        dispatch(setModalSearchBoxState(isOpen));
    },
});

const SearchButtonContainer = connect(
    null,
    mapDispatchToProps,
)(SearchButton);

export default SearchButtonContainer;
